import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-dark text-white">
      <div className="container-custom section-padding">
        <div className="grid md:grid-cols-3 gap-12">
          {/* Brand Section */}
          <div className="space-y-4">
            <div className="flex items-center space-x-3">
              
              <i className="fas fa-heart text-3xl text-primary mb-1"></i>
             
              <h3 className="text-2xl font-playfair font-bold">PÉTALES DE DOUCEUR</h3>
            </div>
            <p className="text-gray-300">
              Créateur de moments. 
              L'excellence du chocolat artisanal.
            </p>
            <br />
                            <span> N° d'entreprise : 1.030.257.784.</span>
          </div>
          
          {/* Contact Section */}
          <div className="space-y-4">
            <h4 className="text-xl font-bold text-secondary">Contact</h4>
            <div className="space-y-3">
              <p className="flex items-center space-x-3">
                <i className="fas fa-envelope text-primary"></i>
                <span>petalesdedouceur@gmail.com</span>
              </p>
              <p className="flex items-center space-x-3">
                <i className="fas fa-phone text-primary"></i>
                <span>+32 493078798</span>
              </p>
              <p className="flex items-center space-x-3">
                <i className="fas fa-map-marker-alt text-primary"></i>
                <span>Beyne-heusay <br />Liège, Belgique</span>
              </p>
              <p className="flex items-center space-x-3">

              </p>
              
            </div>
          </div>
          
          {/* Social & Newsletter */}
          <div className="space-y-6">
            <div>
              <h4 className="text-xl font-bold text-secondary mb-4">Suivez-nous</h4>
              <div className="flex space-x-4">
                <a 
                  href="https://www.facebook.com/people/Petales-Dedouceur/61576262167502/" 
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-12 h-12 bg-gray-800 rounded-full flex items-center justify-center hover:bg-primary transition-colors duration-300"
                >
                  <i className="fab fa-facebook-f text-xl"></i>
                </a>
                <a 
                  href="https://www.instagram.com/petales_de_douceur/" 
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-12 h-12 bg-gray-800 rounded-full flex items-center justify-center hover:bg-primary transition-colors duration-300"
                >
                  <i className="fab fa-instagram text-xl"></i>
                </a>
              </div>
            </div>
            
            {/* Newsletter */}
            {/* <div>
              <h4 className="text-xl font-bold text-secondary mb-4">Newsletter</h4>
              <div className="flex">
                <input 
                  type="email" 
                  placeholder="Votre email"
                  className="flex-1 px-4 py-3 rounded-l-full bg-gray-800 text-white focus:outline-none focus:ring-2 focus:ring-primary"
                />
                <button className="bg-primary px-6 rounded-r-full hover:bg-pink-700 transition-colors duration-300">
                  <i className="fas fa-paper-plane"></i>
                </button>
              </div>
            </div> */}
          </div>
        </div>
        
        {/* Copyright */}
        <div className="border-t border-gray-800 mt-12 pt-8 text-center text-gray-400">
          <p>&copy; {new Date().getFullYear()} Pétales de Douceur. Tous droits réservés.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;